import { render, staticRenderFns } from "./Impostazioni.vue?vue&type=template&id=55d329bc"
import script from "./Impostazioni.vue?vue&type=script&lang=js"
export * from "./Impostazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports